import { render, staticRenderFns } from "./ProductSetting.vue?vue&type=template&id=10871d00&scoped=true&"
import script from "./ProductSetting.vue?vue&type=script&lang=js&"
export * from "./ProductSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10871d00",
  null
  
)

export default component.exports